<template>
  <v-row class="text-left full-height">
    <v-col cols="12">
      <v-card class="rounded-lg pa-3">
        <v-card-title class="font-weight-bold">Documents</v-card-title>
        <v-data-table
          :headers="documentColumns"
          :items="Documents"
          item-key="id"
          :items-per-page="10"
          class="elevation-0 row-pointer table mx-3"
          loading-text="Loading... Please wait"
          @click:row="
            if ($event.type === 'API') {
              handleRouteToApiDocs($event.id);
            } else {
              handleDocumentDownload($event);
            }
          "
        >
          <template v-slot:[`item.loading`]="{ item }">
            <v-progress-circular
              indeterminate
              :class="{ hidden: !documentsLoading.includes(item.id) }"
              color="brandCyan"
              width="2"
              size="25"
            />
          </template>
        </v-data-table>

        <div></div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import OnboardingService from "@/services/OnboardingService";
import hostConfig from "@/config/hostResolver";

import { mapState } from "vuex";

function initialState() {
  return {
    documentsLoading: [],
    documentColumns: [
      {
        text: "",
        align: "start",
        value: "loading",
        width: "50px",
      },
      {
        text: "Type",
        align: "start",
        value: "type",
        width: "20%",
      },
      {
        text: "Document Name",
        align: "start",
        value: "name",
        width: "40%",
      },
      {
        text: "Description",
        align: "start",
        value: "description",
        width: "40%",
      },
    ],
  };
}
export default {
  name: "Documents",
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return initialState();
  },
  created() {},
  beforeUnmount() {},
  methods: {
    resetPage() {
      Object.assign(this.$data, initialState());
    },

    async handleDocumentDownload(row) {
      if (this.documentsLoading.includes(row.id)) return;

      try {
        this.documentsLoading.push(row.id);
        await OnboardingService.downloadLegalDoc(row.id);
      } catch (e) {
        console.error("Error downloading document", e);
      } finally {
        this.documentsLoading = this.documentsLoading.filter((id) => id !== row.id);
      }
    },
    handleRouteToApiDocs(serviceName) {
      const url = `${hostConfig.apiBaseUrl}/${serviceName}/docs/`;
      console.log("Opening Docs", { url, serviceName });
      window.open(url, "_blank");
    },
  },
  computed: {
    ...mapState(["userProfile", "permissions"]),
    Documents() {
      return [
        {
          id: "privacy_gdpr",
          type: "PDF",
          name: "Privacy Policy",
          description: "Privacy policy",
        },
        {
          id: "terms",
          type: "PDF",
          name: "Terms and Conditions",
          description: "Terms and Conditions",
        },
        !this.permissions.includes("vue:read:microservice-api-docs")
          ? []
          : [
              {
                id: "auth-service",
                type: "API",
                name: "Auth Microservice",
              },
              {
                id: "badge-service",
                type: "API",
                name: "Badge Microservice",
              },
              {
                id: "budget-service-ts",
                type: "API",
                name: "Budget Microservice",
              },
              {
                id: "client-service",
                type: "API",
                name: "Client Microservice",
              },
              {
                id: "group-service-ts",
                type: "API",
                name: "Group Microservice",
              },
              {
                id: "form-service",
                type: "API",
                name: "Form Microservice",
              },
              {
                id: "gcp-secret-service",
                type: "API",
                name: "GCP Secret Microservice",
              },
              {
                id: "inform-service",
                type: "API",
                name: "Inform Microservice",
              },
              {
                id: "onboarding-service-ts",
                type: "API",
                name: "Onboarding Microservice",
              },
              {
                id: "program-service-ts",
                type: "API",
                name: "Program Microservice",
              },
              {
                id: "recognition-service",
                type: "API",
                name: "Recognition Microservice",
              },
              {
                id: "trigger-service",
                type: "API",
                name: "Trigger Microservice",
              },
              {
                id: "user-service-ts",
                type: "API",
                name: "User Microservice",
              },
              {
                id: "validation-service",
                type: "API",
                name: "Validation Microservice",
              },
              {
                id: "wallet-service-ts",
                type: "API",
                name: "Wallet Microservice",
              },
              {
                id: "whitelabel-service",
                type: "API",
                name: "Whitelabel Microservice",
              },
            ],
      ]
        .flat()
        .filter(Boolean);
    },
  },
  watch: {},
};
</script>

<style scoped>
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
